import { filter } from 'rxjs/operators';
import {
  Component,
  OnInit,
  Input,
  HostListener,
  OnChanges,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "ngx-triple-list",
  templateUrl: "./triple-list.component.html",
  styleUrls: ["./triple-list.component.css"],
})
export class TripleListComponent implements OnInit, OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
    this.listA1.forEach((element) => (element.active = false));
    this.checkedMiddleList = [];
  }

  public innerWidth: any;
  public rightList: any = [];

  @Input("listLeft") listLeft: any = [];
  @Input("listA1") listA1: any = [];
  @Input("listLeftDescription") listLeftDescription: any = "";
  @Input("listMiddleDescription") listMiddleDescription: any = "";
  @Input("listRightDescription") listRightDescription: any = "";
  @Input("flatList") flatList: any = [];
  @Input("middleListProperty") middleListProperty: any = "";
  @Input("leftListProperty") leftListProperty: any = "";
  @Input("markedCardsRestritos") markedCardsRestritos: any = [];
  @Input("markedCardsLiberadas") markedCardsLiberadas: any = [];
  @Input("changedCards") changedCards: any = [];
  @Input("checkedIdsLeftList") checkedIdsLeftList : any = [];
  @Input("checkedMiddleList") checkedMiddleList : any = [];
  @Input("checkedIdsRightList") checkedIdsRightList : any = [];

  constructor() {}

  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.initLists();
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.innerWidth = event.target.innerWidth;
  }

  add() {
    for (let item of this.listLeft) {
      if (this.checkedIdsLeftList.includes(item.id)) {
        let mappedRestrictedIds = item[this.leftListProperty].map((a) => a.id);
        item[this.leftListProperty].forEach((el) => {
          this.checkedMiddleList.forEach((element) => {
            if (
              element.id != el.id &&
              !mappedRestrictedIds.includes(element.id)
            ) {
              item[this.leftListProperty].push({
                id: element.id,
                descricao: element.descricao,
              });
              mappedRestrictedIds.push(element.id);
            }
          });
        });

        if (item[this.leftListProperty].length == 0) {
          this.checkedMiddleList.forEach((element) => {
            item[this.leftListProperty].push({
              id: element.id,
              descricao: element.descricao,
            });
          });
        }
        item.updated = true;
      }
    }
  }

  addAll() {
    for (let item of this.listLeft) {
      if (this.checkedIdsLeftList.includes(item.id)) {
        let filteredMccGroup = this.listA1.filter((item) => item.active)[0];
        let mappedRestrictedIds = item[this.leftListProperty].map((a) => a.id);

        item[this.leftListProperty].forEach((el) => {
          filteredMccGroup[this.middleListProperty].forEach((element) => {
            if (
              element.id != el.id &&
              !mappedRestrictedIds.includes(element.id)
            ) {
              item[this.leftListProperty].push({
                id: element.id,
                descricao: element.descricao,
              });
              mappedRestrictedIds.push(element.id);
            }
          });
        });

        if (item[this.leftListProperty].length == 0) {
          filteredMccGroup[this.middleListProperty].forEach((element) => {
            item[this.leftListProperty].push({
              id: element.id,
              descricao: element.descricao,
            });
          });
        }
        item.updated = true;
      }
    }
  }

  remove() {
    for (let item of this.listLeft) {
      let idxToRemove = [];
      let idxToRmvList = [];
      if (this.checkedIdsLeftList.includes(item.id)) {
        item[this.leftListProperty].forEach((el, idx) => {
          let idx2 = this.markedCardsLiberadas.findIndex(
            (x) => el.mccCartaoContaId == x.mccCartaoContaId && el.mcc == x.mcc
          );
          if (idx2 != -1) {
            let idx3 = this.changedCards.findIndex(
              (x) =>
                el.mccCartaoContaId == x.mccCartaoContaId && el.mcc == x.mcc
            );
            if (idx3 == -1) {
              let temp = this.markedCardsLiberadas[idx2];
              temp.tipoRestricao = "R";
              this.changedCards.push(temp);
            }
          }
          this.checkedIdsRightList.forEach((element,idxElement) => {
            if (el.id == element) {
              idxToRemove.push(idx)
              idxToRmvList.push(idxElement)
            }
          });
        });
        item.updated = true;
        let sorted = idxToRemove.sort(function (a, b) {  return b-a;  });
      sorted.forEach(element => {
        item[this.leftListProperty].splice(element, 1);
      });
      }
    }
    this.checkedIdsRightList.splice(0,this.checkedIdsRightList.length)
  }

  removeAll() {
    for (let item of this.listLeft) {
      if (this.checkedIdsLeftList.includes(item.id)) {
        item[this.leftListProperty].forEach((el) => {
          let idx2 = this.markedCardsLiberadas.findIndex(
            (x) => el.mccCartaoContaId == x.mccCartaoContaId && el.mcc == x.mcc
          );
          if (idx2 != -1) {
            let idx3 = this.changedCards.findIndex(
              (x) =>
                el.mccCartaoContaId == x.mccCartaoContaId && el.mcc == x.mcc
            );
            if (idx3 == -1) {
              let temp = this.markedCardsLiberadas[idx2];
              temp.tipoRestricao = "R";
              this.changedCards.push(temp);
            }
          }
        });
        item[this.leftListProperty].splice(
          0,
          item[this.leftListProperty].length
        );

        this.checkedIdsRightList.splice(0,this.checkedIdsRightList);
        item.updated = true;
      }
    }
  }

  selectedlistLeft(itemSelected) {
    for (let item of this.listLeft) {
      if (item.active) {
        item.active = false;
        for (let el of item[this.leftListProperty]) {
          el.active = false;
        }
      }
    }
    itemSelected.active = true;
    this.rightList = itemSelected[this.leftListProperty];
    this.checkedIdsRightList.splice(0,this.checkedIdsRightList.length);
  }

  selectedA1(itemSelected) {
    for (let item of this.flatList) {
      item.active = false;
    }
    itemSelected.active = true;
    this.listA1.forEach((element) => {
      if (element.id == itemSelected.groupId) {
        element.active = true;
      } else {
        element.active = false;
      }
    });

  }

  selectedRightList(itemSelected) {
    for (let item of this.rightList) {
      if (item.active) {
        item.active = false;
      }
    }
    itemSelected.active = true;
  }

  initLists() {
    this.rightList = this.listLeft[0][this.leftListProperty];
    this.listLeft[0].active = true;
  }

  changeCheckboxLeftList(event, item) {
    if (event.target.checked) this.checkedIdsLeftList.push(item.id);
    else
      this.checkedIdsLeftList.splice(
        this.checkedIdsLeftList.indexOf(item.id),
        1
      );
  }

  changeCheckboxRightList(event, item) {
    if (event.target.checked) this.checkedIdsRightList.push(item.id);
    else {
    let idx = this.checkedIdsRightList.indexOf(item.id)
      this.checkedIdsRightList.splice(
        idx,
        1
      );
    }
  }

  changeCheckboxA1(event, item) {
    if (event.target.checked) this.checkedMiddleList.push(item);
    else
      this.checkedMiddleList.splice(
        this.checkedMiddleList.findIndex((x) => x.id === item.id),
        1
      );
  }
}
